module.exports = __webpack_public_path__ + "static/media/sound-bubble-play.83668e92.png";